import axios from "axios";
import { domain } from "../../Links/Links";

export async function requestToExtractProducts(setProductsDataInExplorer) {
    const response = await axios.get(domain + '/extract_products_to_explorer/', {
        withCredentials: true,
    })

    if (response.data) {
        setProductsDataInExplorer(response.data);

        console.log(response.data);
    }
}